import React, { ForwardedRef, useMemo } from 'react';
import clsx from 'clsx';
import * as classes from './Button.module.scss';

type ButtonType = 'button' | 'a';

export interface IButtonProps<B extends ButtonType = 'button'> extends Omit<React.HTMLProps<HTMLElementTagNameMap[B]>, 'as' | 'size' | 'ref'> {
    as?: B;
    variant?: 'primary' | 'secondary';
    size?: 'small' | 'large';
}

export const Button = React.forwardRef(<B extends ButtonType = 'button'>(props: IButtonProps<B>, ref: ForwardedRef<HTMLElementTagNameMap[B]>) => {
    const { as: Component = 'button', variant = 'primary', size = 'large', ...rest } = props;
    const className = useMemo(() => {
        return clsx(
            props.className,
            classes.button,
            variant === 'primary' && classes.primary,
            variant === 'secondary' && classes.secondary,
            size === 'large' && classes.large,
            size === 'small' && classes.small,
        );
    }, [ props.className, variant, size ]);

    // @ts-ignore
    return <Component {...rest} ref={ref} className={className}/>;
});
Button.displayName = 'Button';
